import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';
import { captureMessageForSentry } from '@/helpers/sentry-helper';
import { LastVistedTitleDetails } from '@/stores/title-details.store';

// ?preferred_variant=INTERNATIONAL_OFFERS_EXP:control
// ?preferred_variant=INTERNATIONAL_OFFERS_EXP:variant_1

// ?remove_preferred_experiment=INTERNATIONAL_OFFERS_EXP

export const InternationalOffersExpName = 'INTERNATIONAL_OFFERS_EXP' as const;

export type InternationalOffersExpVariants = ToVariants<typeof InternationalOffersExpVariants>;

export const InternationalOffersExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
} as const;

export default generate(
	InternationalOffersExpName,
	InternationalOffersExpVariants,
	() => true,

	async instance => {
		const routingFullPath = instance.$store.state?.routing.activeRoute.fullPath;
		const titleDetailsFullPath = (
			instance.$store.state?.titleDetails?.lastVisitedTitleDetails as LastVistedTitleDetails
		)?.fullPath;

		if (routingFullPath !== titleDetailsFullPath) {
			await new Promise(resolve => {
				let unwatch: () => void = () => {};

				const timeoutId = setTimeout(() => {
					unwatch(); // Stop watching after timeout
					resolve(false);
					captureMessageForSentry(
						'[InternationalOffersExp isExperimentReady() watcher forced to be resolved after 5s]:',
						{ where: 'InternationalOffersExp' },
						'info'
					);
				}, 5000);

				unwatch = instance.$watch(
					() =>
						(instance.$store.state?.titleDetails?.lastVisitedTitleDetails as LastVistedTitleDetails)
							?.fullPath,
					newPath => {
						if (newPath === routingFullPath) {
							unwatch(); // Stop watching
							resolve(true);
							clearTimeout(timeoutId);
						}
					},
					{ immediate: true }
				);
			});
		}
		// ONLY ACTIVATE EXPERIMENT IF title has no offers.
		return !(instance.$store.state?.titleDetails?.lastVisitedTitleDetails as LastVistedTitleDetails)?.offers
			?.length;
	}
);
